import React from 'react'
import Philips from '@assets/images/icon/philips.svg'
import Snickers from '@assets/images/icon/snickers.svg'
import Snapchat from '@assets/images/icon/snapchat.svg'
import Barbeque from '@assets/images/icon/barbeque.svg'
import Nissan from '@assets/images/icon/nissan.svg'
import Adidas from '@assets/images/icon/adidas.svg'

function AdvertisePartnersLeftToRight() {
  return (
    <div className="ticker left-to-right">
      <div className="ticker__wrap">
        <div className="ticker__content">
          <div className="partnersbox">
            <img src={Philips.src} alt="Philips" />
          </div>
          <div className="partnersbox">
            <img src={Snickers.src} alt="Snickers" />
          </div>
          <div className="partnersbox">
            <img src={Snapchat.src} alt="Snapchat" />
          </div>
          <div className="partnersbox">
            <img src={Barbeque.src} alt="Barbeque" />
          </div>
          <div className="partnersbox">
            <img src={Nissan.src} alt="Nissan" />
          </div>
          <div className="partnersbox">
            <img src={Adidas.src} alt="Adidas" />
          </div>
          <div className="partnersbox">
            <img src={Philips.src} alt="Philips" />
          </div>
          <div className="partnersbox">
            <img src={Snickers.src} alt="Snickers" />
          </div>
          <div className="partnersbox">
            <img src={Snapchat.src} alt="Snapchat" />
          </div>
          <div className="partnersbox">
            <img src={Barbeque.src} alt="Barbeque" />
          </div>
          <div className="partnersbox">
            <img src={Nissan.src} alt="Nissan" />
          </div>
          <div className="partnersbox">
            <img src={Adidas.src} alt="Adidas" />
          </div>
        </div>
        <div className="ticker__content">
          <div className="partnersbox">
            <img src={Philips.src} alt="Philips" />
          </div>
          <div className="partnersbox">
            <img src={Snickers.src} alt="Snickers" />
          </div>
          <div className="partnersbox">
            <img src={Snapchat.src} alt="Snapchat" />
          </div>
          <div className="partnersbox">
            <img src={Barbeque.src} alt="Barbeque" />
          </div>
          <div className="partnersbox">
            <img src={Nissan.src} alt="Nissan" />
          </div>
          <div className="partnersbox">
            <img src={Adidas.src} alt="Adidas" />
          </div>
          <div className="partnersbox">
            <img src={Philips.src} alt="Philips" />
          </div>
          <div className="partnersbox">
            <img src={Snickers.src} alt="Snickers" />
          </div>
          <div className="partnersbox">
            <img src={Snapchat.src} alt="Snapchat" />
          </div>
          <div className="partnersbox">
            <img src={Barbeque.src} alt="Barbeque" />
          </div>
          <div className="partnersbox">
            <img src={Nissan.src} alt="Nissan" />
          </div>
          <div className="partnersbox">
            <img src={Adidas.src} alt="Adidas" />
          </div>
        </div>
      </div>
    </div>
  )
}

export default AdvertisePartnersLeftToRight
